export default __webpack_public_path__ + "static/media/snow-4-night.e9bba97c.svg";